var React = require('react');

function CirclecheckInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.1 0C5.4 0 0 5.4 0 12.1C0 18.8 5.4 24.2 12.1 24.2C18.8 24.2 24.2 18.8 24.2 12.1C24.2 5.4 18.8 0 12.1 0ZM12.1 22C6.6 22 2.2 17.6 2.2 12.1C2.2 6.6 6.6 2.2 12.1 2.2C17.6 2.2 22 6.6 22 12.1C22 17.6 17.6 22 12.1 22Z","fill":"white","key":0}),React.createElement("path",{"d":"M16.6 7.79993L10.4 13.9999L7.50001 11.0999C7.10001 10.6999 6.40001 10.6999 5.90001 11.0999C5.50001 11.4999 5.50001 12.1999 5.90001 12.6999L9.50001 16.2999C9.70001 16.4999 10 16.5999 10.3 16.5999C10.6 16.5999 10.9 16.4999 11.1 16.2999L18.1 9.29993C18.5 8.89993 18.5 8.19993 18.1 7.69993C17.8 7.39993 17.1 7.39993 16.6 7.79993Z","fill":"white","key":1})]);
}

CirclecheckInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = CirclecheckInline;

CirclecheckInline.default = CirclecheckInline;
